import { Component, h } from 'preact';
import { Inquiry } from '../../../../../types/inquiries';

interface InquiryInvoiceNumberDisplayProps {
  inquiry: Inquiry;
  onEditClick: (inquiry: Inquiry) => void;
}

export class InquiryInvoiceNumberDisplay extends Component<InquiryInvoiceNumberDisplayProps> {
  render(props: InquiryInvoiceNumberDisplayProps) {
    const inquiry = props.inquiry;

    if (inquiry.invoiceNumber) {
      return (
        <div className="hi-inqinvnumdisp">
          <span className="d-lg-none">Invoice No. </span>
          { inquiry.invoiceNumber }
          <button className="btn btn-link hi-inqinvnumdisp__edit-button" onClick={ () => props.onEditClick(props.inquiry) }>
            <i className="far fa-edit" />
          </button>
        </div>
      )
    } else {
      return (
        <button className="btn btn-link hi-inqinvnumdisp__no-value-button" onClick={ () => props.onEditClick(props.inquiry) }>
          <i className="fas fa-plus hi-inqinvnumdisp__icon" />
          <span className="hi-inqinvnumdisp__text">Invoice No</span>
        </button>
      );
    }
  }
}
